import axiosInstance from '../axios.config';

export const getUserCoursesList = () => {
    return axiosInstance.get(`/UserCourse`);
}

export const getCourses = () => {
    return axiosInstance.get(`/Course`)
}